
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M21 2H3a2.006 2.006 0 00-2 2v12a2.006 2.006 0 002 2h7v2H9a1 1 0 000 2h6a1 1 0 000-2h-1v-2h7a2.006 2.006 0 002-2V4a2.006 2.006 0 00-2-2zm-1 14H4a1 1 0 01-1-1V5a1 1 0 011-1h16a1 1 0 011 1v10a1 1 0 01-1 1z"}})])
          )
        }
      }
    